import { ProSidebarProvider } from "react-pro-sidebar";
import React from "react";
import { useEffect, useState } from "react";
import { messaging } from "./firebase";
import { getToken } from "firebase/messaging";
import Routes from "./Routes";
import Sidebar1 from "components/Sidebar1";
import LogInEmptyPage from "pages/LogInEmpty";
import { ToastContainer, toast } from "react-toastify";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

function App() {
  // useEffect(() => {
  //   // Create a broadcast channel with the same name as in the service worker
  //   const channel = new BroadcastChannel("firebase-background-message");

  //   // Listen for messages from the service worker
  //   channel.onmessage = (event) => {
  //     // console.log(event)
  //     const payload = event.data;
  //     console.log("Received payload in React component:", payload);
  //     toast.success(payload.notification.body)
  //     // toast.success(payload.notification.body);
  //     // console.log(payload);
  //     console.log(payload.notification.title);
  //     console.log(payload.notification.body);
  //     // setfirst(payload.notification.body)
  //     // Do something with the payload, e.g., update state
  //   };

  //   // Cleanup
  //   return () => {
  //     channel.close();
  //   };
  // }, []);
  // async function requestPermission() {
  //   const permission = await Notification.requestPermission();
  //   if (permission === "granted") {
  //     // Generate Token
  //     const token = await getToken(messaging, {
  //       vapidKey:
  //         "BNxrI0LPKUwfP7YNRXpD75vFD2frz6NLzrtXVJD1qTXJyW9YTExuavSIL2HNqjsxYyf17t0CauNzRp_o8KjPRkI",
  //       // vapidKey:
  //       //   "BHGzfi3X_Lrf571O8XfqaK2PMNRaVYnvumSuyxAgteb1FWOPD5Ii9jL0nxi-xRrRx2nfjr3c5yz1gvN211b7aU8",
  //     });
  //     console.log("Token Gen", token);
  //     // Send this token  to server ( db)
  //   } else if (permission === "denied") {
  //     alert("You denied for the notification");
  //   }
  // }

  // useEffect(() => {
  //   // Req user for notification permission
  //   requestPermission();
  // }, []);

  return (
    <ProSidebarProvider>
      {/* <GoogleReCaptchaProvider
        reCaptchaKey="6LfDmoArAAAAAGxGi95aIdU--gXgThoUALUZOj_1" // your v3 site key
        scriptProps={{
          async: true,
          defer: true,
          appendTo: "head",
          nonce: undefined,
        }}
        container={{
          badge: "bottomright", // or 'bottomright'
        }}
      > */}
        {/* <ToastContainer stacked autoClose={false} /> */}
        <Routes />
      {/* </GoogleReCaptchaProvider> */}
    </ProSidebarProvider>
  );
}

export default App;
